// material-ui
import Box from "@mui/material/Box";

// project import
import { useGetMenuMaster } from "api/menu";

// assets

// ==============================|| DRAWER - USER ||============================== //

export default function NavUser() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  return (
    <Box
      sx={{
        p: 1.25,
        px: !drawerOpen ? 1.25 : 3,
        borderTop: "2px solid",
        borderTopColor: "divider",
      }}
    ></Box>
  );
}
